import {combineReducers} from 'redux';
import flightsReducer from './flights';
import departuresReducer from './departures'
import authReducer from './auth'

export default combineReducers({
  flights: flightsReducer,
  departures: departuresReducer,
})